export default "__VITE_ASSET__Bgq4nZpi__"